export default ({ t }) => YupInstance => YupInstance.email(t('invalid email'))
